import React, { useEffect, useContext, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { Loading, PrairiButton, Welcome } from "@peterfosso/prairi-components";
import { getFunctions, httpsCallable } from "firebase/functions"
import { navBarContext, authContext } from "./context/context";
import Logo from "../assets/prairiwhite.png";
import {
  query,
  collection,
  db,
  where,
  getDocs,
  getDoc,
  doc,
  Timestamp,
  updateDoc,
  addDoc,
  setDoc
} from "../firebase/firebaseApp";
import { updateLatestActions } from "../utils";

const VerifyEmail = () => {
  const { navBarHeight } = useContext(navBarContext);
  let { docId } = useParams();
  const [verified, setVerified] = useState(false)
  const [loading, setLoading] = useState(false);
  const { currentUser } = useContext(authContext);
  const { uid } = currentUser || {};
  const [userData, setUserData] = useState({});
  const [dataFetched, setDataFetched] = useState(false);
  const [showWelcome, setShowWelcome] = useState(false);
  let navigate = useNavigate(); 

  const getDataFromDb = async () => {
    try {
      // Get user data from email
      const email = currentUser?.email;
      const q = query(collection(db, "users"), where("email", "==", email));
      const querySnapshot = await getDocs(q);
      let userData;
      let userId;
      querySnapshot.forEach((doc) => {
        userData = doc.data();
        userId = doc.id;
      });
      return { userData, userId };
    } catch (error) {
      // console.log(error);
      return { userData: null };
    }
  };

  const handleVerify = async () => {
    if (!docId) {
      console.error("No user ID provided");
      return;
    }

    setLoading(true);
    try {
      const functions = getFunctions();
      const verifyUserEmail = httpsCallable(functions, 'verifyUserEmail');
      
      const result = await verifyUserEmail({ id: docId });
      
      if (result.data.success) {
        setVerified(true);
        // Redirect after a short delay

      } else {
        console.error("Verification failed:", result.data.error);
      }
    } catch (error) {
      console.error("Error verifying email:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleVerify();
  }, []); // Empty dependency array means this runs once when component mounts

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { userData, userId } = await getDataFromDb();
        setUserData(userData);
        setDataFetched(true);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (currentUser) {
      fetchData();
    }
  }, [currentUser]);

  useEffect(() => {
    if (currentUser && dataFetched && verified) {
      setTimeout(() => {
        setShowWelcome(true)
      }, 1500)
      setTimeout(() => {
        navigate('/dashboard');
      }, 3000)
    }
  }, [currentUser, dataFetched, verified]);

  return (
    <div className={`w-full`} style={{ marginTop: navBarHeight + 8 }}>
      {dataFetched && <Welcome open={showWelcome}/>}
      <div className="flex flex-col justify-center items-center mt-4">
        {!verified && (
          <Loading
          />
        )}
        {verified && <div className="flex flex-col items-center">           
            <img alt="logo" src={Logo} className="w-1/4" />
            <h1 className="my-4 text-center text-lg md:text-xl">
              Thank you! Your email has been verified.
            </h1>
            </div>}
        {verified && !currentUser && <div className="flex flex-col mt-5 items-center">

            <p className="text-center italic text-silverPrairi text-sm md:text-base">
              Want a smoother experience later? Log in now to skip extra steps.
            </p>
            <PrairiButton
            click={() => navigate('/login')}
            label="Login"
            size="sm"
            rounded="soft"
            border="thinGreen"
          />
          </div>}


      </div>
    </div>
  );
};

export default VerifyEmail;
